var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OpenHub',{attrs:{"loading":_vm.loading,"finishOpen":_vm.finishOpen,"openError":_vm.depositError,"hubId":_vm.getHubId},on:{"open":_vm.openHub,"reOpen":_vm.reOpenHub,"resetOpen":_vm.resetOpen}})}
var staticRenderFns = []

export { render, staticRenderFns }